import styled from 'styled-components';

import { PointsApplied as PointsStyled } from './redeem-reward.styled.default';

export * from './redeem-reward.styled.default';

export const PointsApplied = styled(PointsStyled)`
  font-family: ${Styles.fontFamily.brand};
`;
